import React from 'react';
import { styled } from '@mui/material/styles';
import TextField, { TextFieldProps } from '@mui/material/TextField';

const StyCodeTextField = styled(TextField, {
    name: 'StyCodeTextField',
})({
    '& .MuiInputBase-input': { fontFamily: 'monospace' },
});

export const CodeTextField = (props: TextFieldProps) => (
    <StyCodeTextField {...props} />
);
